<script setup lang="ts">
import CContentQuizQuestionView from '@/presentation/components/content/CContentQuizQuestionView.vue'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

// PROPS
defineProps<{
  quizVersion: QuizVersion | null
  subtitle: string | null
}>()
</script>

<template>
  <div v-if="quizVersion" class="flex flex-col content-center justify-start gap-4">
    <slot name="subtitle">
      <h4 class="flex-1">{{ subtitle }}</h4>
    </slot>
    <c-content-quiz-question-view
      v-for="question in quizVersion.questions"
      :key="`question_${question.id}`"
      :question="question"
    />
  </div>
</template>
